import { AxiosRequestConfig, AxiosRequestHeaders } from "axios"
import { HttpCliente, OpcoesRepositorioBase } from "./repositorioBase.modelos"
import SessaoServico from "@/servicos/sessao.service"

export class RepositorioBase extends HttpCliente {
  public utilizaCache: boolean

  public constructor(opcoesRepositorio: OpcoesRepositorioBase = {}) {
    const baseUrl =
      opcoesRepositorio.baseUrl || process.env.VUE_APP_BACKEND_BASE_URL
    super(baseUrl)

    this.utilizaCache = opcoesRepositorio.utilizaCache || false

    this._inicializarInterceptadorDeRequisicoes()
  }

  protected _inicializarInterceptadorDeRequisicoes = () => {
    this.instance.interceptors.request.use(
      this._manipularRequisicoes,
      this._manipularError
    )
  }

  protected _manipularRequisicoes = (config: AxiosRequestConfig = {}) => {
    const definirHeaders = () => {
      const definirHeadersDeAutorizacao = () => {
        const possuiInformacoesDeAutenticacao =
          SessaoServico.tipo && SessaoServico.token

        if (possuiInformacoesDeAutenticacao) {
          return {
            Authorization: `${SessaoServico.tipo} ${SessaoServico.token}`,
          }
        } else {
          return {
            Authorization: "",
          }
        }
      }

      const definirHeadersDeCacheamento = (): AxiosRequestHeaders => {
        const cabecalhos = config.headers ?? {}
        const jaFoiDefinidoCacheNoLeitor = "X-Timesheet-Cache-Ignore" in cabecalhos === true
        if (jaFoiDefinidoCacheNoLeitor) {
          return cabecalhos
        }
        if (this.utilizaCache) {
          return {
            "x-timesheet-cache-ignore": "false",
          }
        } else {
          return {
            "x-timesheet-cache-ignore": "true",
          }
        }
      }

      const headersDeAutorizacao = definirHeadersDeAutorizacao()
      const headersDeCacheamento = definirHeadersDeCacheamento()

      return {
        ...headersDeAutorizacao,
        ...headersDeCacheamento,
      }
    }

    const headersManipulados = definirHeaders()
    const headersDasConfiguracoes = config.headers ?? {}
    config.headers = { ...headersDasConfiguracoes, ...headersManipulados }

    return this._adicionarTokensParaCancelamento(config)
  }
}
